// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — lang-selector.classic.js, новая — lang-selector.cp.js
import { isCp } from 'libs/design';
import * as classic from './lang-selector.classic';
import * as cp from './lang-selector.cp';

export const LangSelector = isCp ? cp.LangSelector : classic.LangSelector;
